import React, { useMemo } from "react";
import "../styles/shop2000-modern.css";

const COMPETITION_FUELS = [
  { ean: "0104010101", name: "Adblue", className: "fuel-adblue" },
  { ean: "2293000000035", name: "N95", className: "fuel-n95" },
  { ean: "2293000000059", name: "Diesel", className: "fuel-diesel" },
];

const parseShop2000Date = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;

  if (typeof value === "string" && value.includes(" ") && !value.includes("T")) {
    return new Date(value.replace(" ", "T"));
  }

  return new Date(value);
};

const formatDateCZ = (value) => {
  const d = parseShop2000Date(value);
  if (!d || Number.isNaN(d.getTime())) return "---";

  return d.toLocaleDateString("cs-CZ", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const formatPriceCZK = (price) => {
  if (price == null || price === "" || Number.isNaN(Number(price))) return "---";
  return `${Number(price).toFixed(2)} CZK`;
};

export default function Shop2000PricesSection({
  pricesShop2000,
  armexData,
  compact = false,
}) {
  const mostRecentUpdate = useMemo(() => {
    const all = COMPETITION_FUELS.flatMap((fuel) => pricesShop2000?.[fuel.ean] || []);
    if (!all.length) return null;

    const times = all
      .map((p) => parseShop2000Date(p.last_updated))
      .filter((d) => d && !Number.isNaN(d.getTime()))
      .map((d) => d.getTime());

    if (!times.length) return null;

    return new Date(Math.max(...times));
  }, [pricesShop2000]);

  const getPriceData = (ean) => {
    const rows = pricesShop2000?.[ean];

    if (Array.isArray(rows) && rows.length > 0) {
      return [...rows].sort(
        (a, b) =>
          (parseShop2000Date(b.last_updated)?.getTime() || 0) -
          (parseShop2000Date(a.last_updated)?.getTime() || 0)
      )[0];
    }

    return { price: null, last_updated: null };
  };

  if (!pricesShop2000) return null;

  if (compact) {
    return (
      <section className="shop-reference-row">
        <div className="shop-reference-row__label">
          <span>Reference</span>
          <strong>Shop2000</strong>
        </div>

        <div className="shop-reference-row__values">
          {COMPETITION_FUELS.map((fuel) => {
            const priceData = getPriceData(fuel.ean);
            const confirmedShop =
              armexData?.prices?.[fuel.name]?.CZK?.confirmed_shop ?? false;

            return (
              <div key={fuel.ean} className={`shop-reference-cell ${fuel.className}`}>
                <span className="shop-reference-cell__fuel">{fuel.name}</span>

                <strong className="shop-reference-cell__price">
                  {formatPriceCZK(priceData.price)}
                </strong>

                <span
                  className={`shop-reference-cell__status ${
                    confirmedShop ? "is-confirmed" : "is-unconfirmed"
                  }`}
                  title={confirmedShop ? "Potvrzeno" : "Nepotvrzeno"}
                >
                  {confirmedShop ? "OK" : "!"}
                </span>
              </div>
            );
          })}
        </div>

        <div className="shop-reference-row__updated">
          <span>Aktualizace</span>
          <strong>{formatDateCZ(mostRecentUpdate)}</strong>
        </div>
      </section>
    );
  }

  return (
    <section className="shop-card">
      <div className="shop-card__header">
        <div>
          <div className="shop-card__eyebrow">Referenční systém</div>
          <h2 className="shop-card__title">Shop2000</h2>
        </div>

        <div className="shop-card__updated">
          <span>Poslední aktualizace</span>
          <strong>{formatDateCZ(mostRecentUpdate)}</strong>
        </div>
      </div>

      <div className="shop-card__grid">
        {COMPETITION_FUELS.map((fuel) => {
          const priceData = getPriceData(fuel.ean);
          const confirmedShop =
            armexData?.prices?.[fuel.name]?.CZK?.confirmed_shop ?? false;

          return (
           <div key={fuel.ean} className={`shop-price-tile ${fuel.className}`}>
              <div className="shop-price-tile__label">{fuel.name}</div>

              <div className="shop-price-tile__value">
                {formatPriceCZK(priceData.price)}
              </div>

              <div
                className={`shop-price-tile__status ${
                  confirmedShop ? "is-confirmed" : "is-unconfirmed"
                }`}
              >
                {confirmedShop ? "Potvrzeno" : "Nepotvrzeno"}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}